import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { style } from './style';

export type Tab = {
  key: string,
  title: string,
  redirectPath: string | Array<string>,
  active?: boolean,
  // When true, the tab opens its target as a standalone app in a new browser
  // tab (plain anchor) instead of navigating within Manuela (react-router Link).
  external?: boolean,
}

type TabsProps = {
  elements: Array<Tab>,
}
const Tabs = ({ elements }: TabsProps): JSX.Element => {
  const tabs = elements.map(({
    active, redirectPath, title, key, external,
  }) => {
    const path = Array.isArray(redirectPath) ? redirectPath[0] : redirectPath;

    const button = (
      <Button
        variant={ style.variant }
        size={ style.size }
        sx={ {
          color: active ? style.colorActive : style.colorDefault,
        } }
      >
        {title}
      </Button>
    );

    if (external) {
      return (
        <a
          key={ key }
          href={ path }
          target="_blank"
          rel="noopener noreferrer"
          style={ { textDecoration: 'none' } }
        >
          {button}
        </a>
      );
    }

    return (
      <Link key={ key } to={ path }>
        {button}
      </Link>
    );
  });

  return (
    <>
      { tabs }
    </>
  );
};

export default Tabs;
